function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCgIconGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1080 1080",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "ball",
    d: "M1051.1,582C996,679.4 927.9,768.8 848.7,847.8C789.8,907.2 724.8,960.4 654.9,1006.3C561,1072.1 574,1075.1 606.6,1071.7C607.2,1071.6 607.8,1071.5 608.3,1071.3C831.5,1041.9 1012.4,876.2 1061.3,656.5C1061.6,656 1061.8,655.5 1061.9,655C1069.2,623.1 1078.8,560.8 1067.9,560.8C1064.5,560.8 1059.1,566.9 1050.9,582.1L1051.1,582ZM106.7,856.4L107.9,858C108.4,858.7 108.8,859.3 109.3,859.9C179.2,953.7 277.9,1022.1 390.3,1054.5C391.2,1054.9 413.2,1060.8 413.9,1061C449.4,1070 485.2,1050 530.3,1023.8C590.8,987 648.7,946.1 703.5,901.3C737.7,870.8 698.6,865.9 673,867.1C647.4,868.3 490.2,872 375.5,865.9C291.7,861 208.5,848.8 126.8,829.3C122.9,828.3 118.9,827.7 114.9,827.7C95.8,827.7 99.7,845.1 106.8,856.3L106.7,856.4ZM324.3,443C295.3,472.5 231,539.9 192.6,588.1C162.8,625.3 135,663.9 109.1,703.9C94.5,727.1 74.1,756.6 109.5,768.7C194.1,791.2 280.8,805 368.2,810C506,817.3 687.7,811.2 718.1,808.1C748.6,805 758.3,783.7 741.9,766.7C725.4,749.6 611.4,638.7 560.2,588.1C509,537.5 428.5,460.1 413.9,445.5C400.6,433 383.1,425.9 364.8,425.4C349.4,425.3 334.8,431.7 324.2,442.9L324.3,443ZM117.7,209.9C117.4,210.3 115.2,212.8 113,215.6C42.3,308 3.8,421.1 3.3,537.4L3.3,543.4C3.6,589 9.6,634.3 21.3,678.4L22.8,683.7C31.4,709.3 51.3,690.6 62.3,673.6C87.1,634.4 113.9,596.6 142.8,560.2C186.7,504.7 259.8,429.7 289.1,399.3C309.9,381.2 312.2,349.7 294.1,328.9C293.7,328.4 293.2,327.9 292.7,327.4C281.7,316.4 184.7,220.1 170.8,208.5C163,202.3 153.3,199 143.3,199C133.5,198.5 124,202.5 117.7,209.9ZM535.7,4.9C421.3,5.4 310.1,42.6 218.5,111.2C217.8,112 210.8,117.5 210.8,117.5C195,133.4 193.1,152.2 214.5,173.6C233.4,192.5 324.2,280.9 334,289.5C355.4,307.1 386.4,306.6 407.1,288.3C433.9,263.9 524.1,188.3 565.6,157.8C604,129 644.3,102.9 686.3,79.8C722.1,61.5 739.2,47.5 721.3,37.6C720.3,37 719.2,36.4 718,36C661.4,15.8 601.7,5.3 541.6,5L535.7,5L535.7,4.9Z",
    style: {
      fill: "url(#_Radial1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "slice",
    d: "M1051.6,386C1051.2,384.8 1050.8,383.5 1050.4,382.3C1050,381.1 1049.7,379.9 1049.3,378.6C1049.3,378.3 1049,378 1049,377.8C1012.5,263.6 938.9,164.8 839.7,97.3L837.5,95.8C823,87.9 805.6,87.3 790.5,94.3C731.3,117.1 675.5,147.8 624.7,185.7C559.1,233.2 485.7,291.8 463.8,311.3C435.4,329.5 427.1,367.2 445.3,395.6C447.8,399.5 450.7,403.1 454.1,406.4C491.9,443 777.2,722.2 793.1,736.8C813.9,759.8 849.4,761.6 872.3,740.8C872.6,740.5 873,740.2 873.3,739.8C918.5,692.7 958.6,641 993,585.5C1015.8,547.5 1034.2,507 1047.9,464.8C1057.6,439.6 1059,412 1052,385.9L1051.6,386Z",
    style: {
      fill: "rgb(197,12,35)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.18946e-14,520.879,-520,3.18408e-14,540,540)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(153,217,236)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(31,150,205)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgIconGlobe);
export default __webpack_public_path__ + "static/media/cg-icon-globe.1e97f38c661ed4d0d73f3ffe7e190e01.svg";
export { ForwardRef as ReactComponent };